module.exports = __webpack_public_path__ + "img/ontwikkeling.bcb0f980.jpg";